import React, { useState } from 'react';
import UpIcon from '@mui/icons-material/ArrowDropUp';
import DownIcon from '@mui/icons-material/ArrowDropDown';
import { Typography, IconButton, Collapse } from '@material-ui/core';

export type DetailsProps = {
  children: React.ReactNode;
  summary?: React.ReactNode;
  label: string;
};

export const Details = ({ children, summary, label }: DetailsProps): JSX.Element => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: 24,
          marginBottom: 12,
        }}
      >
        <Typography
          component="h3"
          onClick={(): void => setOpen(!open)}
          style={{
            fontSize: 18,
            fontWeight: 'bold',
          }}
        >
          <IconButton aria-label="expand row" size="small">
            {open ? <UpIcon /> : <DownIcon />}
          </IconButton>
          {label}
        </Typography>
        {summary}
      </div>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  );
};
